export default __webpack_public_path__ + "static/media/grey-garbage.a13d368f.svg";